(function($) {

    $.DualMap = function (options) {
        options = options || {};
        this.viewers = options.viewers || window.viewers[0] || [];
        this._containers = options.containers || [];
        this._tile_source_left = options.tile_source_left || 'data_deepzoom/deepzoom.dzi';
        this._tile_source_right = options.tile_source_right || 'data_ortho/deepzoom.dzi';
        this._slider_button = document.getElementById('slider-button');
        
        this.slider_button = document.getElementById('slider-button');
    
        this.left_image = null;
        this.left_image_flag = false;
        this.right_image = null;
        this.right_image_flag = false;
        this._left_rect = new OpenSeadragon.Rect( 0,0,0,0 );
        this._right_rect = new OpenSeadragon.Rect( 0,0,0,0 );
    
        this.division_pt = new OpenSeadragon.Point(0.0, 0.0); 
    
        this._leading_viewer = null;
        
        this.init();
    };

    $.DualMap.prototype = {
        init: function() {
            this._pre_check();
            if (this.slider_button) {
                jQuery(this.slider_button).draggable({
                    containment: '#' + this._container_id,
                    scroll: false,
                });
            }

            //■■■全てを選択不可にする（ナビドラッグ対策）
            document.onselectstart = function(){ return false; };

            if (this.viewers.length == 1) {

                //■■■ナビゲーター使用不可にする
                this.viewers[0].navigator.setMouseNavEnabled(false);

                var self = this;
                this.viewers[0].addHandler('animation', function (viewer) {
                    self._images_clip();
                });
            }

            if (this._containers.length == 1) {
                var container = this._containers[0];
                var $container = jQuery(this._containers[0]);
                this.division_pt = new OpenSeadragon.Point( $container.width() / 2, $container.height() / 2 );
                jQuery(container).hover(
                    //mouseenter
                    function(e) {
                    },
                    //mouseleave
                    function(e) {
                        jQuery(container).trigger("mouseup");
                    }
                );
            }
            else if (this._containers.length == 2) {
                this._bind_containers_events();
            } 
            
        },

        _bind_containers_events: function() {
            var viewer, i, viewers_n = this.viewers.length;
            this._container_manipulation_event_handler_bind = this._container_manipulation_event_handler.bind(this);
            for (i = 0; i < viewers_n; i++) {
                viewer = this.viewers[i];
                viewer.addHandler('zoom', this._container_manipulation_event_handler_bind);
                viewer.addHandler('pan', this._container_manipulation_event_handler_bind);
                viewer.addHandler('rotate', this._container_manipulation_event_handler_bind);
            }
        },

        _container_manipulation_event_handler: function(evt) {
            if (this._leading_viewer == null) {
                this._leading_viewer = evt.eventSource;
            }
            if (this._leading_viewer != evt.eventSource) {
                return;
            }
            
             
            for (var i = 0; i < this.viewers.length; i++) {
                var viewer = this.viewers[i];
                if (viewer != this._leading_viewer) {
                    viewer.viewport.zoomTo(this._leading_viewer.viewport.getZoom());
                    viewer.viewport.panTo(this._leading_viewer.viewport.getCenter());
                    viewer.viewport.setRotation(this._leading_viewer.viewport.getRotation());
                }
             
            }

            this._leading_viewer = null;

        },

        _pre_check: function() {
            var self = this;
            if (this.viewers.length == 0) {
                console.warn("Openseadragonが初期化していません");
            }
            else if (this.viewers.length == 1) { 
                this.viewers[0].addTiledImage( {
                    tileSource: this._tile_source_left,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'left'); 
                    }
                });
            
                this.viewers[0].addTiledImage( {
                    tileSource: this._tile_source_right,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'right'); 
                    }
                });
            }
            else if (this.viewers.length == 2) { 
                this.viewers[0].addTiledImage( {
                    tileSource: this._tile_source_left,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'left'); 
                    }
                });
            
                this.viewers[1].addTiledImage( {
                    tileSource: this._tile_source_right,
                    success: function( event ) {
                        self._on_added_tile_image.call(self, event, 'right'); 
                    }
                });
            }
        },

        _on_added_tile_image: function(event, who) {
            if (who === 'left') {
                this.left_image = event.item;
                this.left_image_flag = true; 
                this._images_loaded(); 
            }
            else {
                this.right_image = event.item;
                this.right_image_flag = true;
                this._images_loaded();
            }

            if (this._both_loaded()) {
                this.emit('abdo-dual-loaded');
            }
        },

        _images_loaded: function() {
            if(!this._both_loaded()){
                return;
            }
    
            this._left_rect.height = this.left_image.getContentSize().y;
            this._right_rect.height = this.right_image.getContentSize().y;

            if (this._containers.length == 1) {
                this._images_clip();
                this._init_clip(); 
            }
        },

        _both_loaded: function() {
            return this.left_image_flag && this.right_image_flag;
        },

        _images_clip: function() {
            //■tileSourceの左右が両方読み込み完了していない場合は処理しない
            if(!this._both_loaded()){
                //console.log("★imagesClip★読み込み未完了");
                return;
            }

            var rox = this.right_image.viewerElementToImageCoordinates( this.division_pt ).x;
            var lox = this.left_image.viewerElementToImageCoordinates( this.division_pt ).x;
            this._right_rect.x = rox ;
            this._right_rect.width = this.right_image.getContentSize().x - rox;
            this._left_rect.width = lox;  


            this.left_image.setClip( this._left_rect );
            this.right_image.setClip( this._right_rect );
        },

        _init_clip: function() {  
            var $handle = jQuery('.slider-handle');
            var $container = $handle.parents('.slider-container'); 
            var dragWidth = $handle.outerWidth(); 
            var containerWidth, containerOffset, minLeft, maxLeft;
            var self = this;

            function updateContainerDimensions() {

                containerWidth = $container.outerWidth();
                containerOffset = $container.offset().left;
                minLeft = containerOffset + 10;
                maxLeft = containerOffset + containerWidth - dragWidth - 10;


                var offset = $handle.offset().left + dragWidth / 2;
                var event;


                event = new jQuery.Event("mousedown");
                event.pageX = offset;

                $handle.trigger( event );


                event = new jQuery.Event("mousemove");
                event.pageX = offset;


                $container.trigger( event );

                $handle.trigger("mouseup"); 
            }


            updateContainerDimensions();


            jQuery(window).resize( updateContainerDimensions );


            $handle.on("mousedown vmousedown", function(e) { 
                var xPosition = $handle.offset().left + dragWidth - e.pageX;
                

                function trackDrag(e) {

                    var leftValue = e.pageX + xPosition - dragWidth;
                        

                    leftValue = Math.max(leftValue, minLeft);
                    leftValue = Math.min(leftValue, maxLeft);

                    var widthPixel = (leftValue + dragWidth/2 - containerOffset);
                    var widthFraction = widthPixel/containerWidth;
                    var widthPercent = widthFraction*100+'%';
                    
                    $handle.css('left', widthPercent);

                    self._update_division_pt.call(self, widthPixel);
                    self._images_clip.call(self);
                } 
 
                $container.on("mousemove vmousemove", trackDrag);


                $handle.add($container).one("mouseup vmouseup", function(e) {
                    $container.unbind("mousemove vmousemove", trackDrag);
                });

                e.preventDefault();

            });
        },

        _update_division_pt: function(offset) {
            this.division_pt.x = offset;
        },

    };

    // イベントの機能を付与
    if (typeof(Emitter) !== 'undefined') {
        Emitter($.DualMap.prototype);
    }
})(ABDOMap);